var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fullscreen-layout',{attrs:{"active":_vm.isMobile() && _vm.$screen.width < 768 && _vm.$screen.portrait}},[_c('div',{},[_c('img',{attrs:{"src":require('@/assets/images/orientation/to-horisontal.gif'),"height":"200","alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }